import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { Router, Params, ActivatedRoute } from '@angular/router';

import { StripeService } from './stripe.service';
import { SnackbarService } from "../shared/services/snackbar.service";

@Component({
    template: require('./stripe.component.html'),
    styles: [require('./stripe.component.less')],
    providers: [StripeService, SnackbarService],
    preserveWhitespaces: true
})

export class StripeComponent implements OnInit {
    constructor(
        private _router: Router,
        private _strpeService: StripeService,
        private _activatedRoute: ActivatedRoute,
        private _mdlSnackbarService: SnackbarService,
    ) {}

    ngOnInit() {
        this._activatedRoute.queryParams.subscribe((params: Params) => {
            let codeData: any = {};

            codeData.code = params['code'];
            this._strpeService.sendStripeAuth(codeData).
                subscribe(res => this.stripeSuccessHandler(res),
                error => this.stripeErrorHandler(error));
        });
    }

    // on stripe success
    stripeSuccessHandler(res: any) {
        this._mdlSnackbarService.showSnackbar('STRIPE_LINK_SUCCESS', 'success');
        this._router.navigate(['pa-settings/payment-options']);
    }

    // on stripe failure
    stripeErrorHandler(error: any) {
        this._mdlSnackbarService.showSnackbar('STRIPE_LINK_ERROR', 'error');
        this._router.navigate(['pa-settings/payment-options']);
    }
}
